// extracted by mini-css-extract-plugin
export default {"container":"container_VFbk_","poster":"poster_pTUNf","description":"description_JgQs9","characteristics":"characteristics_eM2G7","item":"item_RkUHN"};